"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getOsmosysResourceUrl_1 = require("./getOsmosysResourceUrl");
exports.getOsmosysResourceAppAdminUrl = ({ obj, baseUrl }) => {
    let endpoint = getOsmosysResourceUrl_1.getOsmosysResourceUrl({ baseUrl, obj });
    baseUrl = lodash_1.trimEnd(baseUrl, '/');
    endpoint = lodash_1.trimStart(endpoint, '/');
    return `${baseUrl}/admin/${endpoint}`;
};
//# sourceMappingURL=getOsmosysResourceAppAdminUrl.js.map